import github from './github.svg'
import pixelGithub from './pixelarticons--github.svg'
import arrowRight from './pixelarticons--arrow-right.svg'
import article from './pixelarticons--article.svg'
import bookOpen from './pixelarticons--book-open.svg'
import chevronLeft from './pixelarticons--chevron-left.svg'
import chevronRight from './pixelarticons--chevron-right.svg'
import code from './pixelarticons--code.svg'
import contact from './pixelarticons--contact.svg'
import externalLink from './pixelarticons--external-link.svg'
import mailArrowRight from './pixelarticons--mail-arrow-right.svg'
import user from './pixelarticons--user.svg'
import bilibili from './ri--bilibili-fill.svg'
import mail from './pixelarticons--mail.svg'
import laptop from './pixelarticons--device-laptop.svg'
import handsup from './pixelarticons--human-handsup.svg'

export const iconMap = {
  'pixelarticons:github': pixelGithub,
  'pixelarticons:arrow-right': arrowRight,
  'pixelarticons:article': article,
  'pixelarticons:book-open': bookOpen,
  'pixelarticons:chevron-left': chevronLeft,
  'pixelarticons:chevron-right': chevronRight,
  'pixelarticons:code': code,
  'pixelarticons:contact': contact,
  'pixelarticons:external-link': externalLink,
  'pixelarticons:mail-arrow-right': mailArrowRight,
  'pixelarticons:user': user,
  'pixelarticons:mail' : mail,
  'pixelarticons:laptop': laptop,
  'pixelarticons:handsup' : handsup,
  'ri:github-fill': github,
  'ri:bilibili-fill': bilibili,
}
